"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.developmentFrameCCLoader = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const developmentTools_1 = require("../../developmentTools");
const frameCCBaseLoader_1 = require("../../appLoaders/frameCCBaseLoader");
const developmentFrameCCLoader = params => {
    const newProps = {
        ...params,
        developerTools: (0, jsx_runtime_1.jsx)(developmentTools_1.DevelopmentModal, {}),
    };
    (0, frameCCBaseLoader_1.frameCCLoaderBase)(newProps);
};
exports.developmentFrameCCLoader = developmentFrameCCLoader;
//# sourceMappingURL=developmentFrameCCLoader.js.map